import { forEach, has, map, find, isString, isEmpty, endsWith, cloneDeep } from 'lodash';

import ContentZone from 'commons-core-services/models/ContentZone.js';

/* eslint-disable no-underscore-dangle */

class ContentZonesService {
    constructor() {
        this.__contentZones = {};
        this.__loaded = {};
        this.__imageServerUrl = '';

        this.setImageServerBaseUrl = this.setImageServerBaseUrl.bind(this);
        this.getImageServerUrl = this.getImageServerUrl.bind(this);
        this.addContentZones = this.addContentZones.bind(this);
        this.getContentZone = this.getContentZone.bind(this);
        this.hasLoaded = this.hasLoaded.bind(this);
    }

    setImageServerBaseUrl(imageServerBaseUrl) {
        if (!isString(imageServerBaseUrl) || isEmpty(imageServerBaseUrl)) {
            throw new TypeError(
                'ContentZonesService.setImageServerBaseUrl: [imageServerBaseUrl] must be a non-empty string'
            );
        }
        this.__imageServerUrl = `${imageServerBaseUrl}/images/web`;
    }

    getImageServerUrl() {
        return this.__imageServerUrl;
    }

    addContentZones(contentZoneGroups) {
        const czg = cloneDeep(contentZoneGroups);

        forEach(czg, (contentZones, group) => {
            this.__contentZones[group] = map(contentZones, (cz) => {
                return new ContentZone(cz, this.getImageServerUrl());
            });
            this.__loaded[group] = true;
        });
    }

    getContentZone(contentZoneGroup, contentZoneName) {
        if (!isString(contentZoneGroup)) return null;
        if (!isString(contentZoneName)) return null;

        const contentZones = this.__contentZones;

        if (has(contentZones, contentZoneGroup)) {
            const contentZone = find(contentZones[contentZoneGroup], (cz) => {
                return cz && cz.location && endsWith(cz.location, contentZoneName);
            });

            if (contentZone) {
                return contentZone;
            }
        }

        return null;
    }

    hasLoaded(group) {
        if (!isString(group) || isEmpty(group)) {
            return null;
        }
        return !!this.__loaded[group];
    }
}

export default new ContentZonesService();
